<div class="spacerWrapper" fxLayout="column">
    <h2 mat-dialog-title class="dialogTitle">{{ title }}</h2>

    <div mat-dialog-content fxLayoutAlign="center start">
        <table>
            <tr>
                <th class="listLabels"><label>SchoolName</label></th>
                <td>{{ school.schoolName }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Center</label></th>
                <td>{{ school.center }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Route</label></th>
                <td>{{ school.route }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Phone</label></th>
                <td>{{ school.phone }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Phone Ext.</label></th>
                <td>{{ school.phoneExt }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>_5digit</label></th>
                <td>{{ school._5digit }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Fax</label></th>
                <td>{{ school.fax }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>_5digit2</label></th>
                <td>{{ school._5digit2 }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Grades</label></th>
                <td>{{ school.grades }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Area</label></th>
                <td>{{ school.area }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Principal</label></th>
                <td>{{ school.principal }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>StreetAddress</label></th>
                <td>{{ school.streetAddress }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>City</label></th>
                <td>{{ school.city }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Zip</label></th>
                <td>{{ school.zip }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Doegrade1213</label></th>
                <td>{{ school.doegrade1213 }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>PK</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.pk" aria-label="PK"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Elem</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.elem" aria-label="Elem"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Mid</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.mid" aria-label="Mid"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Sr</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.sr" aria-label="Sr"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Tech</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.tech" aria-label="Tech"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Arts</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.arts" aria-label="Arts"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Adult</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.adult" aria-label="Adult"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Ese</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.ese" aria-label="Ese"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Charter</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.charter" aria-label="Charter"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Choice</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.choice" aria-label="Choice"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Magnet</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.magnet" aria-label="Magnet"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Ib</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.ib" aria-label="Ib"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Link</label></th>
                <td>{{ school.link }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>TwoMaps</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.twoMaps" aria-label="TwoMaps"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>PrimaryFunc</label></th>
                <td>{{ school.primaryFunc }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Doegrade1112</label></th>
                <td>{{ school.doegrade1112 }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>EnrollmentPrev</label></th>
                <td>{{ school.enrollmentPrev }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>EnrollmentCurrent</label></th>
                <td>{{ school.enrollmentCurrent }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Title1</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.title1" aria-label="Title1"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>Bell1</label></th>
                <td>{{ school.bell1 }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Bell2</label></th>
                <td>{{ school.bell2 }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Misc1</label></th>
                <td>{{ school.misc1 }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>GKg</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.gKg" aria-label="GKg"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G01</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g01" aria-label="G01"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G02</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g02" aria-label="G02"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G03</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g03" aria-label="G03"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G04</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g04" aria-label="G04"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G05</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g05" aria-label="G05"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G06</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g06" aria-label="G06"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G07</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g07" aria-label="G07"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G08</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g08" aria-label="G08"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G09</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g09" aria-label="G09"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G10</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g10" aria-label="G10"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G11</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g11" aria-label="G11"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G12</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g12" aria-label="G12"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>G31</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.g31" aria-label="G31"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>District</label></th>
                <td>{{ school.district }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Programs</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.programs" aria-label="Programs"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>NextYearMap</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.nextYearMap" aria-label="NextYearMap"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>NextYearTwoM</label></th>
                <td>
                    <mat-checkbox disabled [checked]="school.nextYearTwoMap" aria-label="NextYearTwoMap"></mat-checkbox>
                </td>
            </tr>

            <tr>
                <th class="listLabels"><label>MapAddress</label></th>
                <td>{{ school.mapAddress }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>SchoolPhotoUrl</label></th>
                <td>{{ school.schoolPhotoUrl }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Latitude</label></th>
                <td>{{ school.latitude }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Longitude</label></th>
                <td>{{ school.longitude }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>PrevSchoolName</label></th>
                <td>{{ school.prevSchoolName }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Doegrade1314</label></th>
                <td>{{ school.doegrade1314 }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Rssfeedlink</label></th>
                <td>{{ school.rssfeedlink }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Doegrade1415</label></th>
                <td>{{ school.doegrade1415 }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Doegrade1516</label></th>
                <td>{{ school.doegrade1516 }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Doegrade1617</label></th>
                <td>{{ school.doegrade1617 }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>WebScreenShotUrl</label></th>
                <td>{{ school.webScreenShotUrl }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Description</label></th>
                <td>{{ school.description }}</td>
            </tr>

            <tr>
                <th class="listLabels"><label>Doegrade1718</label></th>
                <td>{{ school.doegrade1718 }}</td>
            </tr>
        </table>
    </div>

    <div class="spacer" fxFlex></div>

    <div mat-dialog-actions align="end">
        <button mat-raised-button type="submit" color="primary" (click)="onSubmit()">OK</button>
    </div>
</div>
